export const GET_EMERGENCY_BANNERS = Object.freeze({
  GET_EMERGENCY_BANNERS: "GET_EMERGENCY_BANNERS",
  REQUEST: "GET_EMERGENCY_BANNERS_REQUEST",
  SUCCESS: "GET_EMERGENCY_BANNERS_SUCCESS",
  FAILURE: "GET_EMERGENCY_BANNERS_FAILURE",
})

export const EMERGENCY_BANNERS_API_STATUS = Object.freeze({
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
})
